import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { base64PdfToBlobUrl } from '@innovamat/radiance-utils';

const ViewerWrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const PdfFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

type Props = {
  pdfBase64: string;
};

function TestReportViewer({ pdfBase64 }: Props): JSX.Element {
  const [blobUrl, setBlobUrl] = useState<string>('');

  useEffect(() => {
    const url = base64PdfToBlobUrl(pdfBase64);
    setBlobUrl(url);

    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [pdfBase64]);

  if (!blobUrl) {
    return <ViewerWrapper />;
  }

  return (
    <ViewerWrapper>
      <PdfFrame src={blobUrl} title="Test Report PDF" />
    </ViewerWrapper>
  );
}

export { TestReportViewer };
